<div class="container">
  <div class="head">
    <div class="head-label" mat-dialog-title>
      {{title}}
    </div>
    <mat-icon class="head-exit" mat-dialog-close="">close</mat-icon>
  </div>

  <div class="content">
    <div *ngFor="let group of originalGroups">
      <div class="selectable-group">
        <mat-checkbox (change)="handleCheckGroup(group.groupStructure, $event.checked)"
                      [checked]="allDishesFromGroupSelected(group.groupStructure)">
          {{ group.name }}
        </mat-checkbox>
      </div>
      <div *ngFor="let product of getProductsFromGroup(group.groupStructure)">
        <div class="selectable-dish">
          <mat-checkbox (change)="handleCheckProduct(product, $event.checked)"
                        [checked]="isSelectedProduct(product)"
                        [matTooltip]="'MENU.IS_NOT_ACTIVE_DISH' | translate"
                        class="selectable-dish-checkbox"
                        matTooltipPosition="right"
          >
          </mat-checkbox>
          <div style="flex-grow: 1">
            <app-menu-product-item [product]="product">
            </app-menu-product-item>
          </div>
        </div>
      </div>
    </div>
    <ng-template #loader>
      <div>
        {{ 'COMMON.LOADING' | translate }}
      </div>
    </ng-template>
  </div>
  <button (click)="save()"
          class="submit-button"
          color="primary"
          mat-raised-button
          matTooltipPosition="left">{{ 'COMMON.SAVE' | translate }}</button>
</div>
